import { Box, Chip, FormControl, Grid, InputLabel, LinearProgress, LinearProgressProps, MenuItem, Select, SelectChangeEvent, TextField, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import QualityCheckFileUploadPanel from "../components/QualityCheckFileUploadPanel";
import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
// import { loadPairList } from "shared/glossaryutils";
import qualityCheckApi from "store/apis/qualityCheckApi";
import axios from "axios";
import { MainTool, mainToolConfig } from "../components/SideMenu";
import { IMessage } from "@stomp/stompjs";
import { fileDownload } from "shared/utils";
import LoadingButton from '@mui/lab/LoadingButton';
import { qualityCheckMyGlossary } from "types/models/QualityCheckMyGlossary";
import { QualityCheckJobStatusUpdateMessage } from "types/models/JobStatusUpdateMessage";
import { JobStatus } from "../types/models/JobStatus";
import { useSelector } from "react-redux";
import { RootState } from "store/store";
import { registerConnectionCloseCallback, stompClient } from "shared/StompClient";
import StatisticDialog from "components/QualitCheck/StatisticDialog";
import { getErrorMessage } from "shared/errorHandler";
import { useTranslation } from 'react-i18next';

type createJobPanelProps = {
    tool: MainTool;
}

const statusProgressMapping: { [key: string]: number } = {
    "PENDING": 0,
    "CONVERTING_PDF": 10,
    "IN_PROGRESS": 20,
    "RUNNING_RETRIEVE_DOC": 40,
    "COMPARE_DOC": 60,
    "RUNNING_ANNOTATE_DOC": 80,
    "COMPLETE": 100,
}

const CreateJobPanel = (props: createJobPanelProps) => {
    const { t } = useTranslation();

    const { tool } = props;

    const isLoggedIn = useSelector((state: RootState) => state.auth.isLoggedIn);

    const { refetch: updateCredit, data: user } = qualityCheckApi.useQualityCheckJobUserProfileQuery();
    const { data, refetch } = qualityCheckApi.useQualityCheckMyGlossaryListQuery();
    const [createJob] = qualityCheckApi.useQualityCheckCreateJobMutation();
    const [createJobBilingual] = qualityCheckApi.useQualityCheckCreateJobBilingualMutation();
    // const [initialChecking, { data: wordCount, isSuccess: isInitialCheckingSuccess, isLoading: isInitialChecking }] = qualityCheckApi.useQualityCheckInitialCheckingMutation();

    const [inputFileType, setInputFileType] = useState("pair");
    const [jobId, setJobId] = useState(-1);
    const [isReadyToDownload, setIsReadyToDownload] = useState(false);
    // const [creditUsage, setCreditUsage] = useState<number>(-1);
    const [isValidGlossary, setIsValidGlossary] = useState(true);
    const [isValidForm, setIsValidForm] = useState(false);
    const [message, setMessage] = useState<QualityCheckJobStatusUpdateMessage>();
    const [status, setStatus] = useState("PENDING...");
    const [progress, setProgress] = useState(0);
    const [connected, setConnected] = useState(false);
    const [downloading, setDownloading] = useState(false);
    const [isStatisticCardOpen, setIsStatisticCardOpen] = useState(false);
    const [statistic, setStatistic] = useState({ total: 0, matched: 0, unmatched: 0 });

    const isButtonDisabled = user?.subscriptionStatus === "ACTIVE" ? !isValidForm || !isValidGlossary : !isValidForm || !isValidGlossary;

    const redirectUrl = process.env.REACT_APP_REDIRECT_URL;

    const [args, setArgs] = useState({
        jobInfo: {
            name: "",
            sourceDoc: [] as File[],
            targetDoc: [] as File[],
            bilingualDoc: [] as File[],
        },
        checkingMode: "",
        glossaryId: [] as number[]
    });

    // stompClient.onWebSocketClose = (evt) => {
    //     if (jobId !== -1 && connected && status !== "COMPLETE" && status !== "ERROR") {
    //         stompClient.deactivate();
    //         stompClient.activate();
    //         stompClient.onConnect = () => {
    //             stompClient.subscribe("/queue/job-result/" + jobId, async (msg: IMessage) => {
    //                 const message: QualityCheckJobStatusUpdateMessage = JSON.parse(msg.body);
    //                 setMessage(message);
    //             });
    //         };
    //     }
    // };

    const validateGlossary = useCallback(() => {
        if (tool !== 'GLOSSARY_CHECK') return;

        if (args.glossaryId.length !== 0) {
            setIsValidGlossary(true);
        } else {
            setIsValidGlossary(false);
        }
    }, [args.glossaryId, tool]);

    useEffect(() => {
        validateGlossary();
    }, [validateGlossary]);

    useEffect(() => {
        if (jobId === -1) return;
        const deregisterConnectionCloseCallback = registerConnectionCloseCallback((frame) => {
            if (jobId !== -1 && connected && status !== "COMPLETE" && status !== "ERROR") {
                stompClient.onConnect = () => {
                    stompClient.subscribe("/queue/job-result/" + jobId, async (msg: IMessage) => {
                        const message: QualityCheckJobStatusUpdateMessage = JSON.parse(msg.body);
                        setMessage(message);
                    });
                };
            }

        });

        return () => {
            deregisterConnectionCloseCallback();
        }

    }, [connected, jobId, status]);

    // useEffect(() => {
    //     // load credit usage data to display when initial checking is success
    //     if (wordCount !== undefined && isInitialCheckingSuccess) {
    //         setCreditUsage(wordCount.sourceWordCount + wordCount.targetWordCount)
    //     }
    // }, [isInitialCheckingSuccess])

    useEffect(() => {
        //validate form
        if (inputFileType === "pair") {
            if (args.jobInfo.sourceDoc.length === 0 || args.jobInfo.targetDoc.length === 0 || args.jobInfo.name === "") {
                setIsValidForm(false)
            } else {
                setIsValidForm(true)
            }
        } else {
            if (args.jobInfo.bilingualDoc.length === 0 || args.jobInfo.name === "") {
                setIsValidForm(false)
            } else {
                setIsValidForm(true)
            }
        }
    }, [args.jobInfo, inputFileType])

    useEffect(() => {
        // request to calculate credit usage when source and target file is uploaded

        // setCreditUsage(-1)
        setJobId(-1)
        setConnected(false);
        updateCredit();
        if (connected) {
            stompClient.deactivate();
        }
        // if ((args.jobInfo.sourceDoc.length > 0 && args.jobInfo.targetDoc.length > 0) || args.jobInfo.bilingualDoc.length > 0) {
        //     initialChecking({ sourceFile: args.jobInfo.sourceDoc[0], targetFile: args.jobInfo.targetDoc[0] })
        //     // setCreditUsage(100);
        // }
    }, [args.jobInfo.sourceDoc, args.jobInfo.targetDoc, args.jobInfo.bilingualDoc, updateCredit])

    useEffect(() => {
        setJobId(-1);
        if (connected) {
            stompClient.deactivate();
        }
        setConnected(false);
        // reset state
        setArgs({
            jobInfo: {
                name: t(mainToolConfig[tool].labelKey),
                sourceDoc: [] as File[],
                targetDoc: [] as File[],
                bilingualDoc: [] as File[],
            },
            checkingMode: mainToolConfig[tool].mode,
            glossaryId: [],
        })
        setIsReadyToDownload(false);
        setIsValidGlossary(tool === 'GLOSSARY_CHECK' ? false : true)
    }, [tool, t])

    useEffect(() => {
        if (jobId !== -1) {
            stompClient.subscribe("/queue/job-result/" + jobId, async (msg: IMessage) => {
                const message: QualityCheckJobStatusUpdateMessage = JSON.parse(msg.body);
                setMessage(message)
            })
        }

    }, [jobId])

    useEffect(() => {
        if (message === undefined) return;
        setStatus(message.status);
        if (message.status.includes("ERROR")) {
            stompClient.deactivate();
            setConnected(false);
            updateCredit();
            toast.error(message.status)
            return
        }
        setProgress(statusProgressMapping[message.status]);
        if (message.status === JobStatus.COMPLETE) {
            const totalResultNumber = message.totalResultNumber;
            const matchedNumber = message.matchedNumber;
            const mismatchedNumber = message.mismatchedNumber;
            setStatistic({ total: totalResultNumber, matched: matchedNumber, unmatched: mismatchedNumber });
            setIsStatisticCardOpen(true);
            stompClient.deactivate();
            setConnected(false);
            updateCredit();
            setIsReadyToDownload(true);
            toast.success(t('createJob.completed'))
        }
    }, [message, updateCredit, t])


    const createUploadHandler = (type: string) => (file: File[]) => {

        if (type === "source") {
            setArgs(prevState => ({
                ...prevState,
                jobInfo: {
                    ...prevState.jobInfo,
                    sourceDoc: file,
                }
            }))
        }

        if (type === "target") {
            setArgs(prevState => ({
                ...prevState,
                jobInfo: {
                    ...prevState.jobInfo,
                    targetDoc: file,
                }
            }))
        }

        if (type === "bilingual") {
            setArgs(prevState => ({
                ...prevState,
                jobInfo: {
                    ...prevState.jobInfo,
                    bilingualDoc: file,
                }
            }))
        }
    };

    const handleDownloadResult = async () => {
        setDownloading(true);
        const fileName = args.jobInfo.name + "_RESULT.zip"
        try {
        const resultFile = await axios.get(`quality-check/${jobId}/result/export`, {
            responseType: 'blob',
        })
        fileDownload(resultFile.data, fileName);
        } catch (error: any) {
            toast.error(error.message);
        } finally {
        setDownloading(false);
        }
    }

    const handleSubmitQualityCheck = async () => {
        setProgress(0)
        setStatus("PENDING...")
        setIsReadyToDownload(false);
        if (isLoggedIn) {
            // if (user!.subscriptionStatus === "INACTIVE" && user!.creditBalance < creditUsage) {
            //     toast.error("Insufficient credit balance, please top-up or subscribe Addcuracy+ to continue!");
            //     return;
            // }
        } else {
            window.location.href = redirectUrl!;
            return;
        }

    const id = toast.loading(t('createJob.uploading'))
        const jobInfoJson = JSON.stringify({
            jobName: args.jobInfo.name,
            checkingMode: args.checkingMode,
            myGlossaryId: args.glossaryId,
        })
        const jobInfoBlob = new Blob([jobInfoJson], { type: "application/json" });
        stompClient.activate();
        setConnected(true);

            await createJob({
                jobInfo: jobInfoBlob,
                sourceFile: args.jobInfo.sourceDoc[0],
            targetFile: args.jobInfo.targetDoc[0],
        })
            .unwrap()
            .then((data) => {
                toast.update(id, { render: t('createJob.submitSuccess'), type: "success", isLoading: false, autoClose: 2000 });
                setJobId(data.jobId);
                updateCredit();
            })
            .catch((error) => {
                // Default error message
                let errorMessage = t('createJob.unexpectedError');

                // Handle specific error cases
                if (error.status === 400 && error.data?.message) {
                    const errorData = JSON.parse(error.data.message.match(/{.+}/)?.[0] || '{}');
                    errorMessage = getErrorMessage(errorData.message) || errorMessage;

                } else if (error.status === 401) {
                    errorMessage = t('createJob.authFail');
                } else if (error.status === 500) {
                    errorMessage = t('createJob.serverError');
                } else if (error.message) {
                    errorMessage = error.message;
                }
                
                toast.update(id, { render: errorMessage, type: "error", isLoading: false, autoClose: 2000 });
                stompClient.deactivate();
                setConnected(false);
            });

        refetch().catch((error) => {
            toast.update(id, { render: t('createJob.updateInfoFail'), type: "error", isLoading: false, autoClose: 2000 });
        })
        }

    const handleSubmitQualityCheckBilingual = async () => {
        setProgress(0)
        setStatus("PENDING...")
        setIsReadyToDownload(false);
        if (isLoggedIn) {
            // if (user!.subscriptionStatus === "INACTIVE" && user!.creditBalance < creditUsage) {
            //     toast.error("Insufficient credit balance, please top-up or subscribe Addcuracy+ to continue!");
            //     return;
            // }
        } else {
            window.location.href = redirectUrl!;
            return;
        }

    const id = toast.loading(t('createJob.uploading'))
        const jobInfoJson = JSON.stringify({
            jobName: args.jobInfo.name,
            checkingMode: args.checkingMode,
            myGlossaryId: args.glossaryId,
        })
        const jobInfoBlob = new Blob([jobInfoJson], { type: "application/json" });
        stompClient.activate();
        setConnected(true);

            await createJobBilingual({
                jobInfo: jobInfoBlob,
                bilingualFile: args.jobInfo.bilingualDoc[0],
            })
            .unwrap()
            .then((data) => {
                toast.update(id, { render: t('createJob.submitSuccess'), type: "success", isLoading: false, autoClose: 2000 });
                setJobId(data.jobId);
                updateCredit();
            })
            .catch((error) => {
                // Default error message
                let errorMessage = t('createJob.unexpectedError');

                // Handle specific error cases
                if (error.status === 400 && error.data?.message) {
                    const errorData = JSON.parse(error.data.message.match(/{.+}/)?.[0] || '{}');
                    errorMessage = getErrorMessage(errorData.message) || errorMessage;

                } else if (error.status === 401) {
                    errorMessage = t('createJob.authFail');
                } else if (error.status === 500) {
                    errorMessage = t('createJob.serverError');
                } else if (error.message) {
                    errorMessage = error.message;
                }

                toast.update(id, { render: errorMessage, type: "error", isLoading: false, autoClose: 2000 });
                stompClient.deactivate();
                setConnected(false);
            });

        refetch()
            .catch(() => {
                toast.update(id, { render: t('createJob.updateInfoFail'), type: "error", isLoading: false, autoClose: 2000 });
            })
    };

    const renderGlossaryHandler = () => {

        const handleChange = (event: SelectChangeEvent<number[]>) => {
            const value = event.target.value as number[];
            if (value.length > 5) {
                return;
            }
            setArgs((prevState) => {
                // 比較前後差異，確定新增或移除的項
                const prevIds = prevState.glossaryId;
                const newIds = value.filter((id) => !prevIds.includes(id)); // 新增的項
                const retainedIds = prevIds.filter((id) => value.includes(id)); // 保留的項

                // 新陣列 = 保留的項 + 新增的項（按點擊順序追加）
                const newGlossaryId = [...retainedIds, ...newIds];

                return {
                    ...prevState,
                    glossaryId: newGlossaryId,
                };
            });
        };

        const handleDelete = (id: number) => {
            setArgs((prevState) => {
                const newGlossaryId = prevState.glossaryId.filter((glossaryId) => glossaryId !== id);
                return {
                    ...prevState,
                    glossaryId: newGlossaryId,
                };
            });
        }

        return (
            <>
                {
                    isLoggedIn &&
                    <Grid container>
                        <Grid item xs={12} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }} style={{ paddingTop: "15px" }}>
                            <Typography variant="subtitle1">
                                {t('createJob.selectFrom')}
                            </Typography>
                            <FormControl sx={{ m: 1, minWidth: 200 }}>
                                <InputLabel>{t('createJob.myGlossary')}</InputLabel>
                                <Select
                                    onChange={handleChange}
                                    autoWidth
                                    label={t('createJob.myGlossary')}
                                    variant="outlined"
                                    value={args.glossaryId}
                                    multiple
                                    MenuProps={{
                                        anchorOrigin: { vertical: "bottom", horizontal: "center" },
                                        PaperProps: {
                                            style: {
                                                maxHeight: 48 * 4.5 + 8,
                                            }
                                        }
                                    }}
                                    renderValue={(selected) => (
                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                            {selected.map((value, index) => (
                                                <Chip
                                                    onMouseDown={(event) => event.stopPropagation()}
                                                    onDelete={() => handleDelete(value)}
                                                    onClick={() => handleDelete(value)}
                                                    key={value}
                                                    label={`${index + 1}. ` + data?.filter((glossary) => glossary.myGlossaryId === value).map((glossary) => glossary.glossaryName)[0]}
                                                />
                                            ))}
                                        </Box>
                                    )}
                                >
                                    {data?.map((glossary: qualityCheckMyGlossary) => (
                                        <MenuItem value={glossary.myGlossaryId}>
                                            {glossary.glossaryName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                }
            </>
        )
    }

    const LinearProgressWithLable = (props: LinearProgressProps & { value: number }) => {

        return (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{ width: '100%', mr: 1 }}>
                    <LinearProgress variant="determinate" {...props} />
                </Box>
                <Box sx={{ minWidth: 35 }}>
                    <Typography variant="body2" color="text.secondary">{`${Math.round(
                        props.value,
                    )}%`}</Typography>
                </Box>
            </Box>
        );
    }

    const renderUploadPanel = (documentType: string, document: File[], handler: (file: File[]) => void) => (
        <Grid item xs={12} md={inputFileType === "pair" ? 6 : 12}>
            <QualityCheckFileUploadPanel
                documentType={documentType}
                document={document}
                onDrop={handler}
            />
        </Grid>
    );

    return (
        <>
            {tool === 'CALL_FIGURES' &&
                <StatisticDialog
                    isOpen={isStatisticCardOpen}
                    onClose={() => setIsStatisticCardOpen(false)}
                    statistic={statistic}
                    handleDownloadResult={handleDownloadResult}
                    downloading={downloading}
                />}
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Typography variant="h5" gutterBottom>
                        {t(mainToolConfig[tool].labelKey)}
                    </Typography>
                    <Typography variant="h6" gutterBottom>
                        {t(mainToolConfig[tool].descriptionKey)}
                    </Typography>
                    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                        <ToggleButtonGroup
                            value={inputFileType}
                            exclusive
                            onChange={() => { setInputFileType(inputFileType === "pair" ? "bilingual" : "pair") }}
                            aria-label="input file type"
                            sx={{ height: "100%", display: "flex" }}
                            size="small"
                        >
                            <ToggleButton value="pair" aria-label="pair">
                                {t('createJob.pair')}
                            </ToggleButton>
                            <ToggleButton value="bilingual" aria-label="bilingual">
                                {t('createJob.bilingual')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Box>
                </Grid>
                {inputFileType === "bilingual" &&
                    renderUploadPanel('bilingual', args.jobInfo.bilingualDoc, createUploadHandler('bilingual'))
                }
                {inputFileType === "pair" &&
                    renderUploadPanel('source', args.jobInfo.sourceDoc, createUploadHandler('source'))
                }
                {inputFileType === "pair" &&
                    renderUploadPanel('target', args.jobInfo.targetDoc, createUploadHandler('target'))
                }
                {tool === 'GLOSSARY_CHECK' && renderGlossaryHandler()}
                {
                    isLoggedIn &&
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            required
                            label={
                                <span color="black">
                                    {t('createJob.jobName')}
                                </span>
                            }
                            size="medium"
                            variant="outlined"
                            value={args.jobInfo.name}
                            onChange={(event) => { setArgs(prevState => ({ ...prevState, jobInfo: { ...prevState.jobInfo, name: event.target.value } })) }}
                            sx={{
                                borderColor: "black",
                                "& .MuiOutlinedInput-root": {
                                    "& fieldset": {
                                        borderColor: "black"
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: 'black'
                                    }
                                },

                            }}
                        />
                    </Grid>
                }
                {/* <Grid item xs={12}>
                    <Typography>
                        Usage: {creditUsage !== -1 && creditUsage}
                    </Typography>
                </Grid> */}
                <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                    <Box sx={{ width: '100%', display: "flex", justifyContent: "center" }}>
                        <LoadingButton
                            sx={{ color: "black" }}
                            onClick={inputFileType === "pair" ? handleSubmitQualityCheck : handleSubmitQualityCheckBilingual}
                            disabled={isButtonDisabled}
                            loading={connected}
                        >
                            {t('createJob.start')}
                        </LoadingButton>
                        {isReadyToDownload &&
                            <LoadingButton
                                onClick={handleDownloadResult}
                                loading={downloading}
                            >
                                {t('createJob.download')}
                            </LoadingButton>
                        }
                    </Box>
                    {jobId !== -1 &&
                        <Box sx={{ width: '100%' }}>
                            <Typography color={"gray"}>{status}</Typography>
                            <LinearProgressWithLable value={progress} />
                            <Typography>
                                {t('createJob.statusHint')}
                            </Typography>
                        </Box>
                    }
                </Grid>
            </Grid >
        </>

    )
}

export default CreateJobPanel;
